import axios from "axios";
import { message } from "antd";
import { delete_area_price } from "../../../api/Server";

export const handleDeleteArea = async (record, messageApi, contextHolder) => {
  try {
    const formdata = new FormData();
    formdata.append("area_price_id", record.id);

    const response = await axios.post(delete_area_price, formdata);

    messageApi
      .open({
        type: "loading",
        content: "Action in progress..",
        duration: 2.5,
      })
      .then(() => message.success(response.data.msg, 2.5));
  } catch (error) {
    console.error("Error", error);
  }
};
